export default __webpack_public_path__ + "images/VO.d0740ac.png";